import { takeLatest, put, call } from 'redux-saga/effects';
import * as CorporateListAction from './action';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_RESPONSE_TYPE_ARRAYBUFFER,METERING_HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import { CORE_API,REPORT } from '../../../config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export function* getCorporateList(action) {
    const requestUrl = `${CORE_API}/corporate/contractingentity?page=${action.data.pageDescription.pageNo}&size=${action.data.pageDescription.pageSize}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'POST', data: action?.data?.requestBody ?? {} , headers: HTTP_HEADERS });
        yield put(CorporateListAction.listCorporateSuccess(createResult.data));
    } catch (err) {
        if (!err.response) {
            yield put(CorporateListAction.listCorporateFailure(false))
        } else {
            yield put(CorporateListAction.listCorporateFailure(err))
        }

    }
}
export function* getCorporate() {
    yield takeLatest(CorporateListAction.LIST_CORPORATE, getCorporateList);
}

export function* checkTransactionData(action) {
    let requestUrl = `${CORE_API}/corporate/transaction/data/checkexists`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'POST', data: action.data, headers: HTTP_HEADERS });
        yield put(CorporateListAction.transactionDataCheckSuccess(createResult.data));
    } catch (err) {
        yield put(CorporateListAction.transactionDataCheckFailure(err))
    }
}
export function* checkTransactionDataExist() {
    yield takeLatest(CorporateListAction.TRANSACTION_CHECK_EXIST, checkTransactionData);
}

export function* transactionDataUpload(action) {
    let requestUrl = `${CORE_API}/corporate/transaction/data/upload/${action.data.corporateId}`;
    const formData = new FormData();
    formData.append('file', action.data.file);
    formData.append('fromDate', action.data.fromDate);
    formData.append('toDate', action.data.toDate);
    try {
        const createResult = yield call(request, requestUrl, { method: 'POST', data: formData, headers: HTTP_HEADERS_FORMDATA });
        yield put(CorporateListAction.transactionDataFileUploadSuccess(createResult.data));
    } catch (err) {
        yield put(CorporateListAction.transactionDataFileUploadFailure(err))
    }
}
export function* transactionDataFileUpload() {
    yield takeLatest(CorporateListAction.TRANSACTION_DATA_FILE_UPLOAD, transactionDataUpload);
}

export function* getTransactionDataList(action) {
    let requestUrl = `${CORE_API}/corporate/transaction/data/list/${action.data.corporateId}/${action.data.pageNumber}/${action.data.pageSize}/sort/${action.data.sortField}/${action.data.sortDirection}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CorporateListAction.transactionDataListSuccess(createResult.data));
    } catch (err) {
        yield put(CorporateListAction.transactionDataListFailure(err))
    }
}
export function* fetchTransactionDataList() {
    yield takeLatest(CorporateListAction.TRANSACTION_DATA_LIST, getTransactionDataList);
}

export function* downloadTemplate(action) {
    let requestUrl = `${CORE_API}/corporate/transaction/data/download/template/${action.data}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(CorporateListAction.downloadTransactionTemplateSuccess(createResult.data));
    } catch (err) {
        yield put(CorporateListAction.downloadTransactionTemplateFailure(err))
    }
}
export function* downloadTransactionTemplate() {
    yield takeLatest(CorporateListAction.DOWNLOAD_TRANSACTION_TEMPLATE, downloadTemplate);
}

export function* deleteTransaction(action) {
    let requestUrl = `${CORE_API}/corporate/transaction/data/delete/${action.data}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'DELETE', headers: HTTP_HEADERS });
        yield put(CorporateListAction.deleteTransactionDataSuccess(createResult.data));
    } catch (err) {
        yield put(CorporateListAction.deleteTransactionDataFailure(err))
    }
}
export function* deleteTransactionData() {
    yield takeLatest(CorporateListAction.DELETE_TRANSACTION_DATA, deleteTransaction);
}

export function* downloadFile(action) {
    let requestUrl = `${CORE_API}/corporate/transaction/data/download/s3/${action.data}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CorporateListAction.downloadTransactionFileSuccess(createResult.data));
    } catch (err) {
        yield put(CorporateListAction.downloadTransactionFileFailure(err))
    }
}
export function* downloadTransactionFile() {
    yield takeLatest(CorporateListAction.DOWNLOAD_TRANSACTION_FILE, downloadFile);
}
export function* downloadExcel(action) {
    let requestUrl = `${CORE_API}/keyextraction/excel/corporate/financial`;
    try {
        const createResult = yield call(request, requestUrl, {data:action.data, method: 'POST', headers: HTTP_HEADERS,responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  } );
        yield put(CorporateListAction.downloadExcelFileSuccess(createResult));
    } catch (err) {
        yield put(CorporateListAction.downloadExcelFileFailure(err))
    }
}
export function* downloadExcelFile() {
    yield takeLatest(CorporateListAction.DOWNLOAD_EXCEL_FILE, downloadExcel);
}
export function* downloadNonFinancialExcel(action) {
    let requestUrl = `${CORE_API}/keyextraction/excel/corporate`;
    try {
        const createResult = yield call(request, requestUrl, {data:action.data, method: 'POST', headers: HTTP_HEADERS,responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  } );
        yield put(CorporateListAction.downloadNonFinancialExcelFileSuccess(createResult));
    } catch (err) {
        yield put(CorporateListAction.downloadNonFinancialExcelFileFailure(err))
    }
}
export function* downloadNonFinancialExcelFile() {
    yield takeLatest(CorporateListAction.DOWNLOAD_NON_FINANCIAL_EXCEL_FILE, downloadNonFinancialExcel);
}



export function* downloadObjectListExcel(action) {
    let requestUrl = `${CORE_API}/keyextraction/excel/corporate/objectList`;
    try {
        const createResult = yield call(request, requestUrl, {data:action.data, method: 'POST', headers: HTTP_HEADERS,responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  } );
        yield put(CorporateListAction.downloadObjectListExcelFileSuccess(createResult));
    } catch (err) {
        yield put(CorporateListAction.downloadObjectListExcelFileFailure(err))
    }
}
export function* downloadObjectListExcelFile() {
    yield takeLatest(CorporateListAction.DOWNLOAD_OBJECT_LIST_EXCEL_FILE, downloadObjectListExcel);
}


export function* downloadScoreBreakupExcel(action) {
    let requestUrl = `${CORE_API}/score/extract`;
    try {
        const createResult = yield call(request, requestUrl, {data:action.data, method: 'POST', headers: HTTP_HEADERS,responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  } );
        yield put(CorporateListAction.downloadScoreBreakupExcelFileSuccess(createResult));
    } catch (err) {
        yield put(CorporateListAction.downloadScoreBreakupExcelFileFailure(err))
    }
}
export function* downloadScoreBreakupExcelFile() {
    yield takeLatest(CorporateListAction.DOWNLOAD_SCORE_BREAKUP_EXCEL_FILE, downloadScoreBreakupExcel);
}

export function* downloadCLMBreakupExcel(action) {
    let requestUrl = `${REPORT}/creditlimit/extract`;
    try {
        const createResult = yield call(request, requestUrl, {data:action.data, method: 'POST', headers: HTTP_HEADERS,responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  } );
        yield put(CorporateListAction.downloadCLMBreakupExcelFileSuccess(createResult));
    } catch (err) {
        yield put(CorporateListAction.downloadCLMBreakupExcelFileFailure(err))
    }
}
export function* downloadCLMBreakupExcelFile() {
    yield takeLatest(CorporateListAction.DOWNLOAD_CLM_BREAKUP_EXCEL_FILE, downloadCLMBreakupExcel);
}


/* ===================== DOWNLOAD CORPORATE CSV ===================== */
function* downloadCorporateCSVSaga({ payload }) {
  const { preloading } = payload;

  try {
    preloading(true);

    const token = localStorage.getItem('id_token');
    if (!token) {
      toast.error('Authentication token not found');
      return;
    }

    const url = `${CORE_API}/corporate/list/download`;

    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: 'text/csv'
    };

    const response = yield call(request, url, {
      method: 'GET',
      headers,
      responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: 'text/csv' });
    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', 'corporates.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(downloadUrl);

    yield put(CorporateListAction.downloadCorporateCSVSuccess());
    toast.success('Corporate CSV downloaded successfully');

  } catch (err) {
    yield put(
      CorporateListAction.downloadCorporateCSVFailure(
        err?.message || 'Download failed'
      )
    );
    toast.error('Failed to download Corporate CSV');
  } finally {
    preloading(false);
  }
}

export function* watchDownloadCorporateCSV() {
  yield takeLatest(CorporateListAction.DOWNLOAD_CORPORATE_CSV_REQUEST, downloadCorporateCSVSaga);
}